<template>
    <div class="order-overview">
        <div class="container">
            <slot />
            <OrderResponseOverview />
            <ShippingMethodOverview />
            <CreditCardOverview />
            <BoletoOverview />
            <PixOverview />
            <PixOpenFinanceOverview />
            <RecurringPaymentWarning />
            <ClickToPayOverview />
            <GooglePayOverview />
            <ApplePayOverview />
        </div>
    </div>
</template>

<script>
import ShippingMethodOverview from './components/ShippingMethodOverview';
import OrderResponseOverview from './components/OrderResponseOverview';
import CreditCardOverview from './components/CreditCardOverview';
import BoletoOverview from './components/BoletoOverview';
import PixOverview from './components/PixOverview';
import PixOpenFinanceOverview from './components/PixOpenFinanceOverview';
import RecurringPaymentWarning from '@/components/RecurringPaymentWarning';
import ClickToPayOverview from './components/ClickToPayOverview';
import GooglePayOverview from './components/GooglePayOverview';
import ApplePayOverview from './components/ApplePayOverview';

export default {
	components: {
		OrderResponseOverview,
		ShippingMethodOverview,
		CreditCardOverview,
		BoletoOverview,
		RecurringPaymentWarning,
		PixOverview,
		ClickToPayOverview,
        GooglePayOverview,
        ApplePayOverview,
        PixOpenFinanceOverview
	}
};
</script>

<style>
.order-overview {
	background: #eff1f3;
	border: 1px solid #eaeef3;
	border-radius: 8px;
}
</style>
